import type { DocEntityHandle } from "building-types/handles/docEntityHandleTypes";
import type { DocEntityNode } from "./docEntityNode";
import type { AllDocEntityParentTypes } from "./docEntityRelationTypes";
import type { DocEntityTypeToParentHandleType } from "./docEntityTypeToParentHandleType";

// What entity types can be written to the clipboard? i.e. copied/cut
export type DocClipboardWritableEntityHandle = Extract<
  DocEntityHandle,
  {
    type: "SETTINGS_SET" | "SETTINGS" | "GROUP" | "ANNOTATION";
  }
>;

export type DocClipboardWritableEntityType = DocClipboardWritableEntityHandle["type"];

export type DocClipboardWritableEntityNode = DocEntityNode<DocClipboardWritableEntityType>;

export const docClipboardWritableEntities: {
  [key in DocClipboardWritableEntityType]: true;
} = {
  SETTINGS_SET: true,
  SETTINGS: true,
  GROUP: true,
  ANNOTATION: true,
} as const;

export const docClipboardWritableEntityTypes = Object.keys(
  docClipboardWritableEntities,
) as DocClipboardWritableEntityType[];

// Helper type to extract valid entity types from writable types
type ValidParentClipboardEntityTypes = Extract<DocClipboardWritableEntityType, keyof DocEntityTypeToParentHandleType>;

// What entity types can be read from the clipboard? i.e. pasted
export type DocClipboardReadableEntityHandle = Extract<
  DocEntityHandle,
  {
    type: AllDocEntityParentTypes<ValidParentClipboardEntityTypes> | "GROUP";
  }
>;

export type DocClipboardReadableEntityType = DocClipboardReadableEntityHandle["type"];

export type DocClipboardReadableEntityNode = DocEntityNode<DocClipboardReadableEntityType>;

export const docClipboardReadableEntities: {
  [key in DocClipboardReadableEntityType]: true;
} = {
  LEVEL: true,
  ROOM: true,
  SETTINGS_SET: true,
  GROUP: true,
  CONTENT_TEMPLATE: true,
  CONTENT_TEMPLATE_INSTANCE: true,
  ELEVATION_VIEW: true,
  SECTION_VIEW: true,
  ROOM_LAYOUT: true,
};

export const docClipboardReadableEntityTypes = Object.keys(
  docClipboardReadableEntities,
) as DocClipboardReadableEntityType[];

export type DocClipboardEntityType = DocClipboardReadableEntityType | DocClipboardWritableEntityType;
